import { css } from '@eti/styles';
import { breakpoints } from '@etg/wings';
export const optionListStyles = css`
  li:first-child {
    font-weight: 800;
  }

  span,
  div {
    pointer-events: none;
  }

  div span:nth-child(2) {
    min-width: fit-content;
  }
`;
export const selectBoxOptionLabelStyles = css`
  justify-content: space-between;
  width: 100%;

  & > span:last-of-type {
    white-space: nowrap;
  }
`;
export const selectBoxStyles = css`
  display: grid;
  grid-area: 3 / 1 / 4 / 4;

  button {
    span {
      pointer-events: none;
    }
  }

  label {
    margin-inline-start: 0;
    text-wrap: wrap;
    width: 80%;

    @media (min-width: ${breakpoints._768}) {
      width: auto;
    }
  }

  @media (min-width: ${breakpoints._768}) {
    grid-area: 3 / 2 / 6 / 4;
    width: 320px;
  }

  @media (min-width: ${breakpoints._970}) {
    width: 272px;
  }

  @media (min-width: ${breakpoints._1170}) {
    width: 336px;
  }
`;
//# sourceMappingURL=styles.js.map